// 问董秘
// 概念、互动、关键词 top 10
import request from '@/utils/request'
import axios from 'axios'
import { stockpoolurl, apiUrl, indexPoolUrl, auth, tokenurl } from './config'
// import { logicalExpression } from '@babel/types';
type dataType = any

console.log('打印=====spl', tokenurl, auth)

export default {
  getToken(): Promise<any> {
    return axios.post(tokenurl, auth, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },

  // 获取交易日
  getTradingDays(params: any, token: string): Promise<any> {
    return axios.get('https://baseinfo.sylapp.cn/tradingdays', {
      params,
      headers: {
        'Token': token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
  },

  getStockPoolList(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: stockpoolurl + '/pool/api/1/strategy/stock/pool/list',
      method: 'get',
      params: data.data,
      headers: data.headers
    })
  },

  // 获取四维猎手股池数据
  getFourHunterPool(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/fourHunter/pool',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },



  // 获取产品配置数据
  getProductConfig(): Promise<any> {
    return axios.get(indexPoolUrl + '/helpmanual/assets/indexPool/indexPool.json')
  },

  // 获取箱体擒龙股池数据（新接口）
  getLadderPoolList(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-stock-pool/api/1/strategy/pool/ladder/list',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 获取筹码大师股池数据
  getChipMasterPool(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-fundflow/api/1/chip/pro/signal',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 获取盟主趋势股池数据
  getMengzhuTrendPool(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/mztrend/pool',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 获取盟主趋势近30天热门案例数据
  getMengzhuTrendCard(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/mztrend/card',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 获取龙头信号股池数据（龙头冲刺/龙头点火）
  getDragonSignalPool(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-stock-pool/api/1/strategy/pool/ladder/list',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 获取龙头信号回测数据跟踪
  getDragonSignalTracking(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/dragonsignal/tracking',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 龙头猎手：最新入选
  getDragonHunterNewChose(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/dragon/hunter/new/chose',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 龙头猎手：数据追踪
  getDragonHunterDataFind(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/dragon/hunter/data/find',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 龙头猎手：热门案例
  getDragonHunterHotCase(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/dragon/hunter/hot/case',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 龙头猎手：往期入选
  getDragonHunterBeforeChose(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/dragon/hunter/before/chose',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 量化淘金：进场/离场信号股池日历（strategyCode: quantgold_buy | quantgold_sell）
  getQuantGoldPool(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: apiUrl + '/rjhy-stock-pool/api/1/strategy/pool/ladder/list',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 量化淘金：数据追踪（period: 2近3月 3近1年 4全部）
  getQuantGoldTrack(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/quant/gold/track',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  },

  // 量化淘金：热门案例（period: 2近3月 3近1年 4全部）
  getQuantGoldHotCase(data: dataType): Promise<{ response?: Response }> {
    return request({
      url: apiUrl + '/rjhy-quota-index/api/1/quant/gold/hot/case',
      method: 'get',
      params: data.data,
      headers: data.headers,
      sign: true,
      newSign: true
    })
  }
}
